import { Box, Center, Heading } from "@chakra-ui/react";
import PageContainer from "../../common/PageContainer";
import RichTextRenderer from "../../common/RichTextRenderer";
import { useGetLegalQuery } from "../../features/cmsApi";

function Legal() {
  const { data, isFetching, isLoading } = useGetLegalQuery();
 

  return (
    <PageContainer
      my={10}
      maxW="container.lg"
      isLoading={isFetching || isLoading}
    >
      <Center>
        <Heading size="6xl" fontWeight={"semibold"}>
          {data?.data?.title || "Legal"}
        </Heading>
      </Center>
      <Box my={10}>
        {data?.data && <RichTextRenderer content={data?.data?.content} />}
      </Box>
    </PageContainer>
  );
}

export default Legal;
